































import { Component, Prop, Vue } from 'vue-property-decorator';
import Role from '@/models/Role';
import UserService from '@/services/UserService';
import User from '@/models/User';

@Component
export default class RoleEdit extends Vue {
    @Prop() public id!: number;
    @Prop() public customerid!: number;

    private Users: any[] = [];
    private OriginalUsers: number[] = [];

    private created() {
        this.LoadUsers();
    }

    private async LoadUsers() {
        const userService = new UserService();
        const response = await userService.LoadCustomerUsers(this.id, this.customerid);
        if (response.Error === true) {
            this.$bvModal.msgBoxOk(`There was an error while trying to load the information`);
        } else {
            if (response.Data != null) {
                this.Users = response.Data.map((val: any) => ({
                    UserId: val.UserId,
                    RoleId: val.RoleId,
                    FirstName: val.UserFirstName,
                    LastName: val.UserLastName,
                    Selected: val.RoleId != null,
                    Option: 0
                }));

                const selectedusers = this.Users.filter((f: any) => f.Selected === true);
                if (selectedusers != null) {
                    this.OriginalUsers = selectedusers.map((val: any) => {
                        return val.UserId;
                    });
                }
            }
        }
    }

    private async OnSubmit() {
        const toAdd: number[] = [];
        const toDelete: number[] = [];

        const selectedUsers = this.Users.filter((f: any) => f.Selected === true);
        if (selectedUsers != null) {
            for (const user of selectedUsers) {
                user.RoleId = this.id;
                if (!this.OriginalUsers.includes(user.UserId)) {
                    user.Option = 1;
                }
            }
        }
        const unselectedUsers = this.Users.filter((f: any) => f.Selected === false);
        if (unselectedUsers != null) {
            for (const user of unselectedUsers) {
                if (this.OriginalUsers.includes(user.UserId)) {
                    user.Option = 2;
                }
            }
        }

        const sendUsers = this.Users.filter((f: any) => f.Option > 0);

        if (sendUsers != null) {
            const userService: UserService = new UserService();
            const response = await userService.SaveRoleUsers(sendUsers.map((val: any) => ({
                UserId: val.UserId,
                RoleId: val.RoleId,
                Option: val.Option
            })));

            if (response.Error === true) {
                this.$bvModal.msgBoxOk(`There was an error while trying to save the information`);
            } else {
                this.$emit('changessaved', this.id > 0);
            }
        }
        this.$emit('editcancelled');
    }

    private OnCancel() {
        this.$emit('editcancelled');
    }
}
